export default "__VITE_ASSET__CQWg92rj__"